import { cx } from "@/utils";

import styles from "./Drawer.module.css";

export type DrawerContentProps = React.HTMLProps<HTMLDivElement>;

const DrawerContent: React.FunctionComponent<DrawerContentProps> = ({
  className,
  ...props
}) => <div className={cx(styles.content, styles.padX, className)} {...props} />;
export default DrawerContent;
